/** IQ game UI snapshot — updated from tvAppBootstrap on each frame. */
export type IqUiSnapshot = {
  hudVisible: boolean;
  pauseVisible: boolean;
  gameOverVisible: boolean;
  score: number;
  progress: string;
  timeLeft: number | null;
  question: string;
  answers: IqAnswer[];
  labels: IqLabel[];
  answerTextSize: number;
};

export type IqAnswer = {
  id: string;
  x: number;
  y: number;
  w: number;
  h: number;
  text: string;
  backgroundColor: string;
};

export type IqLabel = {
  text: string;
  x: number;
  y: number;
  color: string;
  alpha: number;
};

const initial: IqUiSnapshot = {
  hudVisible: false,
  pauseVisible: false,
  gameOverVisible: false,
  score: 0,
  progress: '',
  timeLeft: null,
  question: '',
  answers: [],
  labels: [],
  answerTextSize: 0.05,
};

let snapshot: IqUiSnapshot = { ...initial };
const listeners = new Set<() => void>();

export function getIqUiSnapshot(): IqUiSnapshot {
  return snapshot;
}

export function subscribeIqUi(onStoreChange: () => void): () => void {
  listeners.add(onStoreChange);
  return () => listeners.delete(onStoreChange);
}

export function setIqUiSnapshot(next: IqUiSnapshot): void {
  snapshot = { ...next };
  listeners.forEach((l) => l());
}

export function patchIqUi(patch: Partial<IqUiSnapshot>): void {
  setIqUiSnapshot({ ...snapshot, ...patch });
}

export function resetIqUi(): void {
  setIqUiSnapshot({ ...initial });
}
